import { render, staticRenderFns } from "./RawManage.vue?vue&type=template&id=972c6eae&scoped=true&"
import script from "./RawManage.vue?vue&type=script&lang=js&"
export * from "./RawManage.vue?vue&type=script&lang=js&"
import style0 from "./RawManage.vue?vue&type=style&index=0&id=972c6eae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972c6eae",
  null
  
)

export default component.exports